import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
    queryActivityRoom: (data) => http.post(`${hr}/applyActivityRoom/queryActivityRoom`, data), // 获取所有预约活动室
    queryActivityArea: (data) => http.post(`${hr}/applyActivityRoom/queryActivityArea`, data), // 获取馆场区域设备
    queryPage: (data) => http.post(`${hr}/applyActivityRoom/queryPage`, data), // 获取馆场区域设备
    queryMyReservation: (data) => http.post(`${hr}/applyActivityRoom/queryMyReservation`, data), // 我的预约
    addOrUpdate: (data) => http.post(`${hr}/applyActivityRoom/addOrUpdate`, data), // 新增或者编辑
    cancelApplyActivityRoom: (data) => http.post(`${hr}/applyActivityRoom/cancelApplyActivityRoom`, data), // 取消预定
    exportExcel: (data) => http.post(`${hr}/applyActivityRoom/exportExcel`,data,{responseType: 'blob'}), // 导出
    getApprovalDetail: (data) => http.post(`${hr}/applyActivityRoom/getApprovalDetail`, data), // 获取企微审批
    
    userDirectory: data => http.post(`${hr}/user/directoryGzip`, data),
};
